<div
  class="ui segment text-left"
  fxLayout="row"
  fxLayoutAlign="space-between stretch"
  id="board"
>
  <div
    fxFlex.lt-sm="100%"
    fxFlex.lt-xs="100%"
    fxFlex="55%"
    fxLayout="column"
    fxLayoutGap="30px"
    fxLayoutAlign="start start"
    appPadding="5"
  >
    <h1>E-Services provides you with a single entry point to NCC</h1>

    <p class="desc">
      With an E-Services account, you can see all your transactions and records
      with NCC in one place. Be more organized by creating an account today.
    </p>

    <div>
      <a class="ui button primary" routerLink="/home-page/sign-up"
        >Create an Account</a
      >
    </div>
  </div>

  <div fxFlex class="text-center" fxHide.xs="true">
    <svg
      width="266"
      height="257"
      viewBox="0 0 266 317"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.26"
        d="M242.177 234.259L36.4847 305.417C23.4346 305.417 12.8279 294.832 12.8279 281.809V180.446C12.8279 167.423 23.4346 156.837 36.4847 156.837L242.177 85.6787C255.227 85.6787 265.833 96.2638 265.833 109.287V210.65C265.833 223.729 255.227 234.259 242.177 234.259Z"
        fill="#A7ADFF"
      />
      <path
        opacity="0.13"
        d="M229.515 228.273L23.8233 299.432C10.7732 299.432 0.166565 288.847 0.166565 275.823V174.461C0.166565 161.437 10.7732 150.852 23.8233 150.852L229.515 79.6934C242.565 79.6934 253.172 90.2785 253.172 103.302V204.665C253.116 217.744 242.565 228.273 229.515 228.273Z"
        fill="#A7ADFF"
      />
      <path
        opacity="0.39"
        d="M105.734 198.014L42.2601 219.96C38.2062 219.96 34.9854 216.691 34.9854 212.7V181.444C34.9854 177.398 38.2618 174.184 42.2601 174.184L105.734 152.238C109.787 152.238 113.008 155.507 113.008 159.498V190.754C113.008 194.744 109.787 198.014 105.734 198.014Z"
        fill="white"
      />
      <path
        d="M249.618 51.8727L186.144 73.8189C182.091 73.8189 178.87 70.5491 178.87 66.5589V35.3023C178.87 31.2567 182.146 28.0423 186.144 28.0423L249.618 6.09616C253.672 6.09616 256.893 9.36592 256.893 13.3561V44.6128C256.893 48.603 253.616 51.8727 249.618 51.8727Z"
        fill="#A7ADFF"
      />
      <path
        d="M225.572 43.5598L165.486 64.3421C161.655 64.3421 158.6 61.2386 158.6 57.4701V27.8761C158.6 24.0521 161.71 21.004 165.486 21.004L225.572 0.22168C229.404 0.22168 232.458 3.32518 232.458 7.09371V36.6878C232.458 40.4563 229.349 43.5598 225.572 43.5598Z"
        fill="#E3E5FC"
      />
      <path
        d="M246.23 284.912L186.144 305.694C182.313 305.694 179.258 302.591 179.258 298.822V269.228C179.258 265.404 182.368 262.356 186.144 262.356L246.23 241.574C250.062 241.574 253.116 244.677 253.116 248.446V278.04C253.116 281.809 250.062 284.912 246.23 284.912Z"
        fill="#E3E5FC"
      />
      <path
        d="M146.55 294.943L83.0764 316.889C79.0225 316.889 75.8016 313.619 75.8016 309.629V278.373C75.8016 274.327 79.078 271.113 83.0764 271.113L146.55 249.166C150.604 249.166 153.825 252.436 153.825 256.426V287.683C153.825 291.729 150.548 294.943 146.55 294.943Z"
        fill="#A7ADFF"
      />
      <path
        opacity="0.51"
        d="M105.734 255.152L42.2601 277.098C38.2062 277.098 34.9854 273.828 34.9854 269.838V238.581C34.9854 234.536 38.2618 231.321 42.2601 231.321L105.734 209.375C109.787 209.375 113.008 212.645 113.008 216.635V247.892C113.008 251.882 109.787 255.152 105.734 255.152Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M136.221 235.755C134.666 235.755 133.389 234.48 133.389 232.929V185.711C133.389 184.159 134.666 182.885 136.221 182.885C137.776 182.885 139.053 184.159 139.053 185.711V232.929C139.053 234.48 137.776 235.755 136.221 235.755Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 143.426C150.881 141.985 151.603 140.322 153.103 139.824L228.182 113.111C229.626 112.613 231.292 113.333 231.792 114.829C232.292 116.27 231.57 117.933 230.071 118.432L154.991 145.144C153.547 145.643 151.937 144.867 151.381 143.426Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 153.623C150.881 152.182 151.603 150.52 153.103 150.021L228.182 123.309C229.626 122.81 231.292 123.53 231.792 125.027C232.292 126.467 231.57 128.13 230.071 128.629L154.991 155.341C153.547 155.84 151.937 155.064 151.381 153.623Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 163.82C150.881 162.379 151.603 160.717 153.103 160.218L228.182 133.506C229.626 133.007 231.292 133.727 231.792 135.224C232.292 136.665 231.57 138.327 230.071 138.826L154.991 165.538C153.547 166.037 151.937 165.261 151.381 163.82Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 174.017C150.881 172.577 151.603 170.914 153.103 170.415L228.182 143.703C229.626 143.204 231.292 143.925 231.792 145.421C232.292 146.862 231.57 148.524 230.071 149.023L154.991 175.735C153.547 176.234 151.937 175.514 151.381 174.017Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 184.215C150.881 182.774 151.603 181.111 153.103 180.612L228.182 153.9C229.626 153.401 231.292 154.122 231.792 155.618C232.292 157.059 231.57 158.722 230.071 159.22L154.991 185.933C153.547 186.487 151.937 185.711 151.381 184.215Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 194.467C150.881 193.026 151.603 191.364 153.103 190.865L228.182 164.153C229.626 163.654 231.292 164.374 231.792 165.871C232.292 167.312 231.57 168.974 230.071 169.473L154.991 196.185C153.547 196.684 151.937 195.908 151.381 194.467Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 204.665C150.881 203.224 151.603 201.561 153.103 201.062L228.182 174.35C229.626 173.851 231.292 174.572 231.792 176.068C232.292 177.509 231.57 179.171 230.071 179.67L154.991 206.383C153.547 206.881 151.937 206.105 151.381 204.665Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 214.862C150.881 213.421 151.603 211.758 153.103 211.259L228.182 184.547C229.626 184.048 231.292 184.769 231.792 186.265C232.292 187.706 231.57 189.369 230.071 189.867L154.991 216.58C153.547 217.078 151.937 216.303 151.381 214.862Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 225.059C150.881 223.618 151.603 221.955 153.103 221.457L228.182 194.744C229.626 194.246 231.292 194.966 231.792 196.462C232.292 197.903 231.57 199.566 230.071 200.065L154.991 226.777C153.547 227.276 151.937 226.5 151.381 225.059Z"
        fill="white"
      />
      <path
        opacity="0.51"
        d="M151.381 235.256C150.881 233.815 151.603 232.153 153.103 231.654L228.182 204.942C229.626 204.443 231.292 205.163 231.792 206.66C232.292 208.101 231.57 209.763 230.071 210.262L154.991 236.974C153.547 237.473 151.937 236.697 151.381 235.256Z"
        fill="white"
      />
      <path
        d="M117.34 62.0699C118.062 61.6266 118.784 61.2386 119.506 60.9061C129.446 56.3617 141.163 60.7399 145.717 70.6045C150.271 80.4692 145.883 92.2182 135.999 96.7626L134 92.4399C141.552 89.0038 144.828 80.0813 141.385 72.5442C137.942 65.0072 129.002 61.7374 121.449 65.1734C120.894 65.4505 120.339 65.7276 119.783 66.0601L117.34 62.0699Z"
        fill="#E3E5FC"
      />
      <path
        d="M129.168 97.3168L137.942 98.0927L134.277 90.1122L129.168 97.3168Z"
        fill="#E3E5FC"
      />
      <path
        d="M127.502 100.476C126.78 100.919 126.058 101.307 125.337 101.64C115.396 106.184 103.679 101.806 99.1252 91.9411C94.5716 82.0764 98.9586 70.3275 108.843 65.7831L110.843 70.1058C103.29 73.5418 100.014 82.4643 103.457 90.0014C106.9 97.5385 115.84 100.808 123.393 97.3722C123.948 97.0951 124.504 96.818 125.059 96.4855L127.502 100.476Z"
        fill="#E3E5FC"
      />
      <path
        d="M115.674 65.2288L106.9 64.453L110.565 72.4334L115.674 65.2288Z"
        fill="#E3E5FC"
      />
    </svg>
  </div>
</div>

<div>
  <div
    class="ui box segment"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    routerLink="/home-page/lot"
  >
    <div
      fxFlex
      id="section"
      fxLayout="row"
      fxLayoutGap="25px"
      fxLayoutAlign="start center"
    >
      <div>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32 30.75C32 31.4404 31.4404 32 30.75 32H18.5C17.8096 32 17.25 31.4404 17.25 30.75V7.4375H16C15.3096 7.4375 14.75 6.87793 14.75 6.1875V4.9375H7.25V6.1875C7.25 6.87793 6.69043 7.4375 6 7.4375H4.75V30.75C4.75 31.4404 4.19043 32 3.5 32H1.25C0.55957 32 0 31.4404 0 30.75C0 30.0596 0.55957 29.5 1.25 29.5H2.25V6.1875C2.25 5.49707 2.80957 4.9375 3.5 4.9375H4.75V3.6875C4.75 2.99707 5.30957 2.4375 6 2.4375H9.75V1.25C9.75 0.55957 10.3096 0 11 0C11.6904 0 12.25 0.55957 12.25 1.25V2.4375H16C16.6904 2.4375 17.25 2.99707 17.25 3.6875V4.9375H18.5C18.5061 4.9375 18.512 4.93823 18.5181 4.93848C18.76 4.92944 19.0073 4.99072 19.228 5.12939L27.1594 10.1177C28.7815 11.1379 29.75 12.8911 29.75 14.8076V19.5C29.75 20.1904 29.1904 20.75 28.5 20.75C27.8096 20.75 27.25 20.1904 27.25 19.5V14.8076C27.25 13.7559 26.7185 12.7937 25.8284 12.2339L19.75 8.41113V29.5H22.1875V27.5C22.1875 26.8096 22.7471 26.25 23.4375 26.25C24.1279 26.25 24.6875 26.8096 24.6875 27.5V29.5H27.25V25.6875C27.25 24.9971 27.8096 24.4375 28.5 24.4375C29.1904 24.4375 29.75 24.9971 29.75 25.6875V29.5H30.75C31.4404 29.5 32 30.0596 32 30.75ZM8.4375 15C7.74707 15 7.1875 15.5596 7.1875 16.25V17.5C7.1875 18.1904 7.74707 18.75 8.4375 18.75C9.12793 18.75 9.6875 18.1904 9.6875 17.5V16.25C9.6875 15.5596 9.12793 15 8.4375 15ZM13.4375 15C12.7471 15 12.1875 15.5596 12.1875 16.25V17.5C12.1875 18.1904 12.7471 18.75 13.4375 18.75C14.1279 18.75 14.6875 18.1904 14.6875 17.5V16.25C14.6875 15.5596 14.1279 15 13.4375 15ZM8.4375 20.625C7.74707 20.625 7.1875 21.1846 7.1875 21.875V23.125C7.1875 23.8154 7.74707 24.375 8.4375 24.375C9.12793 24.375 9.6875 23.8154 9.6875 23.125V21.875C9.6875 21.1846 9.12793 20.625 8.4375 20.625ZM13.4375 20.625C12.7471 20.625 12.1875 21.1846 12.1875 21.875V23.125C12.1875 23.8154 12.7471 24.375 13.4375 24.375C14.1279 24.375 14.6875 23.8154 14.6875 23.125V21.875C14.6875 21.1846 14.1279 20.625 13.4375 20.625ZM13.4375 26.25C12.7471 26.25 12.1875 26.8096 12.1875 27.5V28.75C12.1875 29.4404 12.7471 30 13.4375 30C14.1279 30 14.6875 29.4404 14.6875 28.75V27.5C14.6875 26.8096 14.1279 26.25 13.4375 26.25ZM24.6875 16.25C24.6875 15.5596 24.1279 15 23.4375 15C22.7471 15 22.1875 15.5596 22.1875 16.25V17.5C22.1875 18.1904 22.7471 18.75 23.4375 18.75C24.1279 18.75 24.6875 18.1904 24.6875 17.5V16.25ZM23.4375 20.625C22.7471 20.625 22.1875 21.1846 22.1875 21.875V23.125C22.1875 23.8154 22.7471 24.375 23.4375 24.375C24.1279 24.375 24.6875 23.8154 24.6875 23.125V21.875C24.6875 21.1846 24.1279 20.625 23.4375 20.625ZM8.4375 26.25C7.74707 26.25 7.1875 26.8096 7.1875 27.5V28.75C7.1875 29.4404 7.74707 30 8.4375 30C9.12793 30 9.6875 29.4404 9.6875 28.75V27.5C9.6875 26.8096 9.12793 26.25 8.4375 26.25ZM8.4375 9.375C7.74707 9.375 7.1875 9.93457 7.1875 10.625V11.875C7.1875 12.5654 7.74707 13.125 8.4375 13.125C9.12793 13.125 9.6875 12.5654 9.6875 11.875V10.625C9.6875 9.93457 9.12793 9.375 8.4375 9.375ZM13.4375 9.375C12.7471 9.375 12.1875 9.93457 12.1875 10.625V11.875C12.1875 12.5654 12.7471 13.125 13.4375 13.125C14.1279 13.125 14.6875 12.5654 14.6875 11.875V10.625C14.6875 9.93457 14.1279 9.375 13.4375 9.375Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div><span> Pay NCC</span></div>
    </div>
    <div>
      <a class="ui primary button" routerLink="/home-page/pay">Make payment</a>
    </div>
  </div>
</div>

<div class="ui box segment">
  <div fxLayout="row" id="section">
    <div
      fxFlex="grow"
      fxLayout="row"
      fxLayoutGap="25px"
      fxLayoutAlign="start center"
    >
      <div>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 17.8125C16.6904 17.8125 17.25 17.2529 17.25 16.5625V1.25C17.25 0.559625 16.6904 0 16 0C15.3096 0 14.75 0.559625 14.75 1.25V16.5625C14.75 17.2529 15.3096 17.8125 16 17.8125Z"
            fill="#3F4395"
          />
          <path
            d="M13.2795 22.9577C13.2817 22.9599 13.2837 22.962 13.2858 22.9641C14.0172 23.6954 14.9777 24.0609 15.9382 24.0609C16.8979 24.0609 17.8575 23.6958 18.5874 22.9659L25.5072 16.0731C25.9963 15.5859 25.9978 14.7945 25.5107 14.3054C25.0235 13.8163 24.232 13.8147 23.7429 14.3019L16.8214 21.1964C16.5853 21.4324 16.2714 21.5625 15.9375 21.5625C15.6048 21.5625 15.292 21.4334 15.0562 21.1989L8.26522 14.3099C7.78059 13.8182 6.9891 13.8126 6.49747 14.2972C6.00585 14.7819 6.00016 15.5733 6.48478 16.065L13.2795 22.9577Z"
            fill="#3F4395"
          />
          <path
            d="M30.75 25.75C30.0596 25.75 29.5 26.3096 29.5 27C29.5 28.3785 28.3785 29.5 27 29.5H5C3.6215 29.5 2.5 28.3785 2.5 27C2.5 26.3096 1.94037 25.75 1.25 25.75C0.559625 25.75 0 26.3096 0 27C0 29.757 2.243 32 5 32H27C29.757 32 32 29.757 32 27C32 26.3096 31.4404 25.75 30.75 25.75Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div>
        <span style="color: #3f4395">Download Receipt</span>
      </div>
    </div>
    <div fxFlex="10%" class="text-right">
      <button
        class="ui gray circular tiny icon button"
        (click)="collapseReceiptStatus = !collapseReceiptStatus"
      >
        <i
          [ngClass]="
            collapseReceiptStatus ? 'chevron down icon' : 'chevron up icon'
          "
        ></i>
      </button>
    </div>
  </div>

  <div [suiCollapse]="collapseReceiptStatus">
    <div *ngIf="errorMsg">
        <esl-message-toast [(message)]="errorMsg"></esl-message-toast>
    </div>
    <div
      class="ui basic segment"
      appPadding
      paddingL="50px"
      fxLayout="row"
      fxLayoutGap="20px"
    >
      <div class="ui form" fxFlex="60%" [ngClass]="{ loading: pending }">
        <div class="fields">
          <div class="twelve wide field">
            <label id="tertiary"
              >REMITA RETRIEVAL REFERENCE (RRR)/Transaction Reference</label
            >
            <input
              type="text"
              [formControl]="receiptField"
              placeholder="Enter RRR/Transaction Reference"
            />
          </div>
          <div class="four field">
            <label>&nbsp;</label>
            <button class="ui primary button" (click)="submitReceipt()">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Download Old receipt -->
<div class="ui box segment">
  <div fxLayout="row" id="section">
    <div
      fxFlex="grow"
      fxLayout="row"
      fxLayoutGap="25px"
      fxLayoutAlign="start center"
    >
      <div>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 17.8125C16.6904 17.8125 17.25 17.2529 17.25 16.5625V1.25C17.25 0.559625 16.6904 0 16 0C15.3096 0 14.75 0.559625 14.75 1.25V16.5625C14.75 17.2529 15.3096 17.8125 16 17.8125Z"
            fill="#3F4395"
          />
          <path
            d="M13.2795 22.9577C13.2817 22.9599 13.2837 22.962 13.2858 22.9641C14.0172 23.6954 14.9777 24.0609 15.9382 24.0609C16.8979 24.0609 17.8575 23.6958 18.5874 22.9659L25.5072 16.0731C25.9963 15.5859 25.9978 14.7945 25.5107 14.3054C25.0235 13.8163 24.232 13.8147 23.7429 14.3019L16.8214 21.1964C16.5853 21.4324 16.2714 21.5625 15.9375 21.5625C15.6048 21.5625 15.292 21.4334 15.0562 21.1989L8.26522 14.3099C7.78059 13.8182 6.9891 13.8126 6.49747 14.2972C6.00585 14.7819 6.00016 15.5733 6.48478 16.065L13.2795 22.9577Z"
            fill="#3F4395"
          />
          <path
            d="M30.75 25.75C30.0596 25.75 29.5 26.3096 29.5 27C29.5 28.3785 28.3785 29.5 27 29.5H5C3.6215 29.5 2.5 28.3785 2.5 27C2.5 26.3096 1.94037 25.75 1.25 25.75C0.559625 25.75 0 26.3096 0 27C0 29.757 2.243 32 5 32H27C29.757 32 32 29.757 32 27C32 26.3096 31.4404 25.75 30.75 25.75Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div>
        <span style="color: #3f4395">Download Receipts for Online Payments Made Before 15th April 2022</span>
      </div>
    </div>
    <div fxFlex="10%" class="text-right">
      <button
        class="ui gray circular tiny icon button"
        (click)="collapseOldReceiptStatus = !collapseOldReceiptStatus"
      >
        <i
          [ngClass]="
            collapseOldReceiptStatus ? 'chevron down icon' : 'chevron up icon'
          "
        ></i>
      </button>
    </div>
  </div>

  <div [suiCollapse]="collapseOldReceiptStatus">
    <esl-message-toast [(message)]="errorMsg"></esl-message-toast>
    <div
      class="ui basic segment"
      appPadding
      paddingL="50px"
      fxLayout="row"
      fxLayoutGap="20px"
    >
      <div class="ui form" fxFlex="60%" [ngClass]="{ loading: pending }">
        <div class="fields">
          <div class="twelve wide field">
            <label id="tertiary"
              >REMITA RETRIEVAL REFERENCE (RRR)/Transaction Reference</label
            >
            <input
              type="text"
              [formControl]="oldReceiptField"
              placeholder="Enter RRR/Transaction Reference"
            />
          </div>
          <div class="four field">
            <label>&nbsp;</label>
            <button class="ui primary button" (click)="submitOldReceipt()">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="ui box segment">
  <div fxLayout="row" id="section">
    <div
      fxFlex="grow"
      fxLayout="row"
      fxLayoutGap="25px"
      fxLayoutAlign="start center"
    >
      <div>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 9.1875C16.6904 9.1875 17.25 8.62786 17.25 7.9375C17.25 7.24714 16.6904 6.6875 16 6.6875C15.3096 6.6875 14.75 7.24714 14.75 7.9375C14.75 8.62786 15.3096 9.1875 16 9.1875Z"
            fill="#3F4395"
          />
          <path
            d="M27.3137 4.68625C24.2917 1.66431 20.2737 0 16 0C11.7263 0 7.70831 1.66431 4.68625 4.68625C1.66431 7.70831 0 11.7263 0 16C0 20.2737 1.66431 24.2917 4.68625 27.3137C7.70831 30.3357 11.7263 32 16 32C18.9258 32 21.7886 31.2026 24.2788 29.6942C24.8693 29.3364 25.058 28.5678 24.7003 27.9774C24.3426 27.3869 23.574 27.1982 22.9836 27.5559C20.884 28.8278 18.4691 29.5 16 29.5C8.55606 29.5 2.5 23.4439 2.5 16C2.5 8.55606 8.55606 2.5 16 2.5C23.4439 2.5 29.5 8.55606 29.5 16C29.5 18.6618 28.7084 21.2528 27.2108 23.4928C26.8271 24.0666 26.9813 24.8429 27.5553 25.2266C28.1292 25.6103 28.9054 25.4562 29.2891 24.8822C31.0626 22.2296 32 19.1581 32 16C32 11.7263 30.3357 7.70831 27.3137 4.68625Z"
            fill="#3F4395"
          />
          <path
            d="M16 11.6875C15.3096 11.6875 14.75 12.2471 14.75 12.9375V24.0625C14.75 24.7529 15.3096 25.3125 16 25.3125C16.6904 25.3125 17.25 24.7529 17.25 24.0625V12.9375C17.25 12.2471 16.6904 11.6875 16 11.6875Z"
            fill="#3F4395"
          />
        </svg>
      </div>
      <div>
        <span style="color: #3f4395"> Check Payment Status</span>
      </div>
    </div>
    <div fxFlex="10%" class="text-right">
      <button
        class="ui gray circular tiny icon button"
        (click)="collapsePaymentStatus = !collapsePaymentStatus"
      >
        <i
          [ngClass]="
            collapsePaymentStatus ? 'chevron down icon' : 'chevron up icon'
          "
        ></i>
      </button>
    </div>
  </div>
  <div [suiCollapse]="collapsePaymentStatus">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <div
      class="ui basic segment"
      appPadding
      paddingL="50px"
      fxLayout="row"
      fxLayoutGap="20px"
    >
      <div class="ui form" fxFlex="60%" [ngClass]="{ loading: pending }">
        <div class="fields">
          <div class="twelve wide field">
            <label id="tertiary"
              >REMITA RETRIEVAL REFERENCE (RRR)/Transaction Reference</label
            >
            <input
              type="text"
              [formControl]="paymentField"
              placeholder="Enter RRR/Transaction Reference"
            />
          </div>
          <div class="four field">
            <label>&nbsp;</label>
            <button type="submit" class="ui primary button" (click)="submit()">
              Submit
            </button>
          </div>
        </div>
      </div>

      <div fxFlex="30%" fxLayout="column" fxLayoutGap="10px" *ngIf="paymentIRR">
        <div fxFlex>
          <span style="color: #bbbbc0"><strong>AMOUNT</strong></span>
          <h2 class="ui primary header">
            {{ paymentIRR?.currencyCode }}
            {{ paymentIRR?.amount | number: ".2-2" }}
          </h2>
        </div>
        <div appMargin marginB="10px">
          <span style="color: #bbbbc0"><strong>PAYMENT STATUS</strong></span>
          <div>
            <span
              class="ui label"
              [ngClass]="{
                red: paymentIRR.status == 'UNPAID',
                green: paymentIRR.status == 'PAID'
              }"
              >{{ paymentIRR?.status }}</span
            >
          </div>
        </div>
        <div fxFlex *ngIf="paymentIRR.status == 'AWAITING_PAYMENT'">
          <button
            class="ui primary button"
            (click)="goToPayment(paymentIRR)"
            *ngIf="paymentIRR.currencyCode == '₦'"
            target="_blank"
            >Pay Now</button
          >
          <a
            class="ui primary button"
            href="{{ paymentIRR.paymentUrl }}"
            *ngIf="paymentIRR.currencyCode != '₦'"
            target="_blank"
            >Upload Proof of Payment</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
